import styled from 'styled-components';

export const NoBusFound = styled.div(props=>`
    padding: 40px;
    border-radius: 8px;
    background-color: #ffffff;
    margin-top: 40px;
    display: flex;
    align-items: center;
    .imgWrap {
        width: 135px;
        height: 107px;
        padding: 10px;
        margin-right: 32px;
        flex-shrink: 0;
    }
    .noBusFoundHeading {
        color: ${props.theme ? props.theme.colors.downriver.base : '#141823'};
        font-family: ${props.theme && props.theme.font.fontFamily};
        font-size: ${props.theme && props.theme.font.custom(28)};
        font-weight: bold;
        margin-bottom: 4px;
    }
    p:not(.noBusFoundHeading) {
        font-family: 'roboto';
        color: ${props.theme ? props.theme.colors.downriver.medium : '#777'};
        font-size: 2rem;
        line-height: 3.2rem;
    }
`);